import React from "react";
import {ColumnsType} from "antd/es/table";
import {FIELD_TYPE, TT_THUOC, TT_VTYT} from "types/enums";
import {ColumnProps} from "types/models";
import {formatDateToString} from "helper/common";
import {DataFormField} from "types/models/input-field-type";
import {ColumnsEdit} from "types/models/column-table-edit";
import {Form, Tooltip, Typography} from "antd";
import dayjs from "dayjs";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, CODE, NUMBER} = FIELD_TYPE;

const allColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    disabledCheck: true,
    align: "center",
    fixed: "left",
    width: 60,
    isResizable: true,
  },
  {
    title: "Số giấy phép",
    key: "soGiayPhep",
    show: true,
    dataIndex: "soGiayPhep",
    width: 150,
    align: "center",
    isResizable: true,
  },
  {
    title: "Sở y tế",
    key: "soYTe",
    show: true,
    dataIndex: "soYTe",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Ngày có hiệu lực",
    key: "ngayCoHieuLuc",
    show: true,
    dataIndex: "ngayCoHieuLuc",
    width: 150,
    align: "center",
    isResizable: true,
    render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  },
  {
    title: "Phạm vi hoạt động",
    key: "phamViHoatDong",
    show: true,
    dataIndex: "phamViHoatDong",
    width: 150,
    align: "left",
    isResizable: true,
  },

  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    width: 100,
    align: "center",
    fixed: "right",
  },
];

export {allColumns};
